import { render } from "./LoaderSpinner.vue?vue&type=template&id=05a50be5&scoped=true"
import script from "./LoaderSpinner.vue?vue&type=script&lang=js"
export * from "./LoaderSpinner.vue?vue&type=script&lang=js"

import "./LoaderSpinner.vue?vue&type=style&index=0&id=05a50be5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a50be5"]])

export default __exports__